export default "__VITE_ASSET__DJY3tnEV__"